export const IFRAME_ID = "qoreai_chat";

export type ExecutionOptions = {
  fingerprint?: string;
};

export interface Execute {
  (options?: ExecutionOptions): Promise<void>;
}
